import React, {useState, useEffect} from 'react'
import './Home.scss'

import MarketplaceSlider from './MarketplaceSlider/MarketplaceSlider';

import MarketplaceBlock from './MarketplaceBlock/MarketplaceBlock';
import CollectionBlock from './CollectionBlock/CollectionBlock';
import SellerBlock from './SellerBlock/SellerBlock';
import EventBlock from './EventBlock/EventBlock';
import GalleryBlock from './GalleryBlock/GalleryBlock';

import Filter from './Filter/Filter';

import Back from '../Assets/home/Mask_Group.png'

import Skull from '../Assets/home/c501c162725691 4.png'

import DemoImg from '../Assets/home/image_205.png'

import Fire from '../Assets/home/fire.svg'

import Demo1 from '../Assets/home/image_323.png'
import Demo2 from '../Assets/home/image_321.png'
import Demo3 from '../Assets/home/image_320.png'
import Demo4 from '../Assets/home/image_206.png'
import Demo5 from '../Assets/home/image_203.png'

import Author from '../Assets/home/053.png'

import NftDemo1 from '../Assets/home/05china05.png'
import NftDemo2 from '../Assets/home/04china04.png'

import Seller from '../Assets/home/seller.png'

import Event from '../Assets/home/event.png'

import NTF1 from '../Assets/home/nft1.png'
import NTF2 from '../Assets/home/nft2.png'
import NTF3 from '../Assets/home/nft3.png'
import NTF4 from '../Assets/home/nft4.png'
import NTF5 from '../Assets/home/nft5.png'
import NTF6 from '../Assets/home/nft6.png'
import NTF7 from '../Assets/home/nft7.png'


function Home(props) {

  const nftExamples = [
    {value: "Demo Title", img: Demo1},
    {value: "Demo Title", img: Demo2},
    {value: "Demo Title", img: Demo3},
    {value: "Demo Title", img: Demo4},
    {value: "Demo Title", img: Demo5}
  ]
  
  const [sliderNum, setSliderNum] = useState(0)

  const [width, setWidth] = useState(0);
  
  let  [collectionSliderRow] = useState(1)
  let  [collectionSliderShow] = useState(4)
  let  [exampleSliderShow] = useState(4)
  let  [sellersSliderShow] = useState(4)
  let  [eventSliderShow] = useState(2)


  useEffect(() => {
    const updateWindowDimensions = () => {
      const newWidth = window.innerWidth;
      setWidth(newWidth);
    };

    window.addEventListener("resize", updateWindowDimensions);

    return () => window.removeEventListener("resize", updateWindowDimensions) 

  }, [width]);


  if(window.innerWidth <= 1024 && window.innerWidth >= 800){
    collectionSliderShow = 3
  }else if(window.innerWidth <= 800 && window.innerWidth >= 600){
    collectionSliderRow = 2
    collectionSliderShow = 2
  }else if(window.innerWidth <= 600){
    collectionSliderShow = 1
    collectionSliderRow = 2
  }
  if(window.innerWidth <= 1024 && window.innerWidth >= 800){
    exampleSliderShow = 3
  }else if(window.innerWidth <= 800 && window.innerWidth >= 600){
    exampleSliderShow = 2
  }else if(window.innerWidth <= 600){
    exampleSliderShow = 1
  }

  if(window.innerWidth <= 1024 && window.innerWidth >= 800){
    sellersSliderShow = 3
  }else if(window.innerWidth <= 800){
    sellersSliderShow = 2
  }

  if(window.innerWidth <= 1024){
    eventSliderShow = 1
  }


  

  const nftExamplesSlider = [
      {value: "Demo Title0", img: DemoImg},
      {value: "Demo Title1", img: DemoImg},
      {value: "Demo Title2", img: DemoImg}
  ]



  const nftImgs = nftExamples.map((el, index) => {
      return(
          <div key={index} style={{ backgroundImage: `linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 50.77%), url(${el.img})` }}>
              <span>{el.value}</span>
          </div>
      )
  })

  
  const CollectionSlides = [
    {value: "Collection 1 [Title]", img: NftDemo1, author: Author},
    {value: "Collection 2 [Title]", img: NftDemo2, author: Author},
    {value: "Collection 3 [Title]", img: NftDemo2, author: Author},
    {value: "Collection 4 [Title]", img: NftDemo2, author: Author},
    {value: "Collection 5 [Title]", img: NftDemo2, author: Author},      
    {value: "Collection 6 [Title]", img: NftDemo2, author: Author}
  ]

  const nftSlidesImgs = [
    {value: "Demo Title0", img: NftDemo1},
    {value: "Demo Title1", img: NftDemo2},
    {value: "Demo Title2", img: NftDemo2},
    {value: "Demo Title1", img: NftDemo2},
    {value: "Demo Title2", img: NftDemo2},      
    {value: "Demo Title2", img: NftDemo2}
  ]

  const sellersInfo = [
    {title: 'Artist_Title', img: Seller},
    {title: 'Artist_Title', img: Seller},
    {title: 'Artist_Title', img: Seller},
    {title: 'Artist_Title', img: Seller},
    {title: 'Artist_Title', img: Seller},
    {title: 'Artist_Title', img: Seller},
    {title: 'Artist_Title', img: Seller},
    {title: 'Artist_Title', img: Seller},
    {title: 'Artist_Title', img: Seller},
    {title: 'Artist_Title', img: Seller},
    {title: 'Artist_Title', img: Seller},
    {title: 'Artist_Title', img: Seller},
    {title: 'Artist_Title', img: Seller},
    {title: 'Artist_Title', img: Seller},
    {title: 'Artist_Title', img: Seller},
  ]  
  
  const eventValues = [
    {value: "NFT Crypto Comicon", img: Event, author: Seller, nickname: "@nickname", description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed...", date: "17.04.2021", views: 555 },
    {value: "NFT Crypto Comicon", img: Event, author: Seller, nickname: "@nickname", description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed...", date: "17.04.2021", views: 555 },
    {value: "NFT Crypto Comicon", img: Event, author: Seller, nickname: "@nickname", description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed...", date: "17.04.2021", views: 555 }
  ]

  const ExploreFilters = [
    {title: 'All', active: true}, 
    {title: 'Art', active: false}, 
    {title: 'Crypto', active: false}, 
    {title: 'Gaming', active: false}, 
    {title: 'Business', active: false}, 
    {title: 'Media', active: false}, 
    {title: 'Sports', active: false}
  ]

  let [postNum, setPostNum] = useState(8)

  let [loadMore, setLoadMore] = useState("load more")



  const explorerValues = [
    {img: NTF1, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: true, bundle: false, pack: false},
    {img: NTF2, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: false, bundle: false, pack: false},
    {img: NTF3, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: true, bundle: false, pack: false},
    {img: NTF4, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: true, bundle: false, pack: false},
    {img: NTF5, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: false, bundle: 'Bundle of 5', pack: false},      
    {img: NTF6, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: false, bundle: false, pack: true},
    {img: NTF5, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: 'SOLD', lastBet: false, bundle: false, pack: false},      
    {img: NTF7, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: false, bundle: false, pack: true},
    {img: NTF1, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: true, bundle: false, pack: false},
    {img: NTF2, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: false, bundle: false, pack: false},
    {img: NTF3, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: true, bundle: false, pack: false},
    {img: NTF4, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: true, bundle: false, pack: false},
    {img: NTF6, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: '0.053 ETH', lastBet: false, bundle: false, pack: true},
    {img: NTF5, value: "Demo Title, Demo Title", author: '@user123', likes: '1.2 k', price: 'SOLD', lastBet: false, bundle: false, pack: false}
  ]

  function showMore(){
    if(postNum < explorerValues.length - 4){
      setPostNum(postNum+4)
    }else if(postNum < explorerValues.length){
      setPostNum(postNum + (explorerValues.length-postNum))
      setLoadMore("No more NFT'S")
    }
  }

  return(
    <div className={props.darkMode ? "home dark" :"home"}>
      <div className="own_nft_n_examples">
        <div className="ur_own_ntf" style={{ backgroundImage: `url(${Back})` }}>
          <div>
            <h1>CREATE YOUR NFT</h1>
            <button>Create NFT</button>
          </div>
          <img src={Skull} alt="skull"/>
        </div>
        <div className="nft_example" style={{ backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.69) 0%, rgba(0, 0, 0, 0) 54.14%, #000000 106.51%), url(${nftExamplesSlider[sliderNum].img})` }}>
            <span>{nftExamplesSlider[sliderNum].value}</span>
            <div>
              <button style={{ background: sliderNum === 0 ? '#0085FF' : ''  }} onClick={() => setSliderNum(0)}/>
              <button style={{ background: sliderNum === 1 ? '#0085FF' : ''  }} onClick={() => setSliderNum(1)}/>
              <button style={{ background: sliderNum === 2 ? '#0085FF' : ''  }} onClick={() => setSliderNum(2)}/>
            </div>
          </div>
        </div>
        <div className="nft_demo">
          {nftImgs}
        </div>
        <div className="top_collections">
          <h1>Top collections in 
            <h2>
              <select id="cars">
                <option>1 day</option>
                <option>7 days</option>
                <option>30 days</option>
              </select>
            </h2>
          </h1>
          <MarketplaceSlider darkMode={props.darkMode} nftSlidesImgs={CollectionSlides} component={ CollectionBlock } slidesPerRow={collectionSliderRow} slidesToShow={collectionSliderShow}/>
        </div>
        <div className="top_bids">
          <h1>Top bids <img src={Fire} alt="fire"/></h1>
          <MarketplaceSlider darkMode={props.darkMode} nftSlidesImgs={nftSlidesImgs} component={ MarketplaceBlock } slidesPerRow={1} slidesToShow={exampleSliderShow}/>
        </div>
        <div className="top_sellers">
          <h1>Top sellers</h1>
          <MarketplaceSlider darkMode={props.darkMode} nftSlidesImgs={sellersInfo} component={ SellerBlock } slidesPerRow={3} slidesToShow={sellersSliderShow}/>
        </div>  
        <div className="popular_events">
          <h1>Popular events</h1>
          <MarketplaceSlider darkMode={props.darkMode} nftSlidesImgs={eventValues} component={ EventBlock } slidesPerRow={1} slidesToShow={eventSliderShow}/>
        </div>              
        <div className="explorer">
          <h1>Explore</h1>
          <Filter arr={ExploreFilters} darkMode={props.darkMode} />
          <div className="home_gallery" style={{ display: 'flex', flexWrap: 'wrap'}}>
            <GalleryBlock nftBlocks={explorerValues} postNum={postNum} darkMode={props.darkMode} />
          </div>
          <button onClick={() => showMore()} className="load_more">{loadMore}</button>
      </div>
    </div>
  )
}

export default Home;